export var Equal;
(function (Equal) {
    function array(element) {
        return (a, b) => {
            for (let i = 0; i < a.length || i < b.length; i++) {
                if (a.length <= i || b.length <= i) {
                    return false;
                }
                if (!element(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        };
    }
    Equal.array = array;
    function identity() {
        return Object.is;
    }
    Equal.identity = identity;
    function object(properties) {
        return (a, b) => {
            return Object.entries(properties).every(([key, equal]) => equal(a[key], b[key]));
        };
    }
    Equal.object = object;
})(Equal || (Equal = {}));
//# sourceMappingURL=equal.js.map